module.exports = __webpack_public_path__ + "public/rightArrow.svg?0079a97d";